import * as React from 'react';
import moment from 'moment-timezone';

import { Container, CurrentContainerStatus } from 'types/Watchlist';

import { getDeltaLastFreeDay } from 'pages/TrackAndTrace/components/container-table/columns/utility';
import { formatDate } from 'utils/common';
import { CellProps } from './types';
import { DualCell } from './DualCell';

interface ArrivalProps {
  time: string;
  timezone: string;
  estimated: boolean;
  showEstimated?: boolean;
}

export const DATE_DISPLAY_FORMAT = 'ddd, MMM D';

const DisplayArrival: React.FC<ArrivalProps> = (props) => {
  const { time, timezone, estimated, showEstimated } = props;

  const dayDelta = getDeltaLastFreeDay(time);

  const formattedDate = formatDate(time, DATE_DISPLAY_FORMAT, timezone);
  const topText = `${formattedDate} ${timezone ? moment().tz(timezone).zoneAbbr() : ''}`;

  const dayText = dayDelta === 0 ? 'Today' : `In ${Math.abs(dayDelta)} days`;

  let bottomText = dayDelta > 0 ? 'Arrived' : dayText;

  if (showEstimated && estimated) {
    if (dayDelta > 0) {
      bottomText = 'Estimated';
    } else {
      bottomText = `${bottomText} • Estimated`;
    }
  } else if (dayDelta > 0) {
    bottomText = 'Actual';
  } else {
    bottomText = `${bottomText} • Actual`;
  }

  return (
    <DualCell topText={formattedDate ? topText : null} bottomText={bottomText} showBottomText />
  );
};

export const VesselArrival: React.FC<CellProps> = (props) => {
  const container: Container = props.row;
  const timezone = container?.vesselArrival?.timezone;

  const actualDate = container.vesselArrival?.actual;
  if (actualDate && timezone) {
    return <DisplayArrival time={actualDate} timezone={timezone} estimated={false} />;
  }

  const estimatedDate = container.vesselArrival?.estimated;
  const showEstimated =
    container.currentStatus === CurrentContainerStatus.OnVessel ||
    container.currentStatus === CurrentContainerStatus.Manifested ||
    container.currentStatus === CurrentContainerStatus.Unknown;

  if (estimatedDate && timezone) {
    return (
      <DisplayArrival
        time={estimatedDate}
        timezone={timezone}
        estimated
        showEstimated={showEstimated}
      />
    );
  }

  return <DualCell topText={null} />;
};
VesselArrival.displayName = 'ContainerTable.VesselArrival';
